<h1 mat-dialog-title>{{ data?.title }}</h1>

<div mat-dialog-content class="ml-popup-content">
  <app-produto-mercado-livre [produtoId]="produtoId"></app-produto-mercado-livre>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close(false)">Fechar</button>
</div>
